// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
var useScrollToTop = function (_a) {
    var path = _a.path, _b = _a.scrollTop, scrollTop = _b === void 0 ? true : _b;
    var pathname = useLocation().pathname;
    var prevPath = useRef();
    var sanitizedPath = path.replace('/*', '');
    useEffect(function () {
        if (prevPath.current !== sanitizedPath && scrollTop && pathname.match(sanitizedPath)) {
            var root = document.getElementById('root') || window;
            prevPath.current = sanitizedPath;
            root.scrollTo(0, 0);
        }
        else if (prevPath.current && !pathname.match(sanitizedPath)) {
            prevPath.current = null;
        }
    }, [pathname]);
    return null;
};
export default useScrollToTop;
